var useMapEaqTopicToHesiExamByCourseId = function (_a) {
    var courses = _a.courses, eaqTopicMappedHesiExamByISBN = _a.eaqTopicMappedHesiExamByISBN, isEHRModalShowing = _a.isEHRModalShowing;
    if (isEHRModalShowing) {
        return courses.filter(function (c) {
            return c.entitlements.some(function (etm) {
                var _a;
                return ((_a = eaqTopicMappedHesiExamByISBN[etm.isbn]) === null || _a === void 0 ? void 0 : _a.length) > 0;
            });
        });
    }
    return [];
};
export default useMapEaqTopicToHesiExamByCourseId;
